document.addEventListener('DOMContentLoaded', function () {
  const inputs = document.querySelectorAll('[data-search-rotator]');
  if (!inputs.length) return;

  const brands = [
    'Buscar Samsung...',
    'Buscar Apple...',
    'Buscar Xiaomi...',
    'Buscar iPhone...',
    'Buscar Motorola...',
    'Buscar OnePlus...',
    'Buscar Google Pixel...',
    'Buscar realme...',
    'Buscar OPPO...',
    'Buscar Huawei...',
  ];

  inputs.forEach(function (input) {
    if (input.value) return;

    let index = 0;
    let timer = null;

    function rotate() {
      input.style.opacity = '0';
      setTimeout(function () {
        input.setAttribute('placeholder', brands[index % brands.length]);
        input.style.opacity = '1';
        index++;
      }, 300);
    }

    rotate();
    timer = setInterval(rotate, 2600);

    input.addEventListener('focus', function () {
      clearInterval(timer);
      input.style.opacity = '1';
    });

    input.addEventListener('blur', function () {
      if (!input.value) {
        timer = setInterval(rotate, 2600);
      }
    });
  });
});
